import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      <p>Copyright © 2023 | Created by  
            <a href="www.rachelandersondooley.com" alt="portfolio link"> Rachel Dooley
            </a>
        </p>
    </div>
  )
}

export default Footer
